import { render, staticRenderFns } from "./SpawnerOverlay.vue?vue&type=template&id=87f727ca&"
import script from "./SpawnerOverlay.vue?vue&type=script&lang=js&"
export * from "./SpawnerOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports